import styled from 'styled-components';

import { SearchBox, SearchBoxProps } from '@components/search-box';
import { pxToRem } from '@utils/converters';

export type ExpandableSearchProps = SearchBoxProps;

export const ExpandableSearch = (props: ExpandableSearchProps) => (
  <Container>
    <SearchBox onChangeDebounce={500} placeholder="" {...props} />
  </Container>
);

const Container = styled.div({
  '.input-container:not(:focus-within)': {
    cursor: 'pointer',
  },
  input: {
    width: 0,
    margin: 0,
    padding: 0,
    transition: 'width 0.4s ease',
  },
  'input:focus, [data-hasvalue="true"] input': {
    width: pxToRem(190),
  },
  // Hide the text-clear icon from SearchBox while not expanded
  '&:not(:focus-within) [data-hasvalue="false"] .text-clear-icon': {
    width: 0,
  },
});
